export class ShadowContainer {
    private containerContents: HTMLElement | null = null;
    private container: HTMLDivElement;
    private visible: boolean = false;
    private id: string;

    private targetX: number = 0;
    private targetY: number = 0;
    private currentX: number = 0;
    private currentY: number = 0;
    private animationFrame: number | null = null;

    constructor(id: string = `shadow-container-${Date.now()}`) {
        this.id = id;

        let existing = document.getElementById(this.id) as HTMLDivElement | null;
        if (existing) {
            this.container = existing;
        } else {
            this.container = document.createElement("div");
            this.container.id = this.id;
            Object.assign(this.container.style, {
                position: "fixed",
                top: "0px",
                left: "0px",
                display: "none",
                zIndex: "9999",
                transition: "none",
                willChange: "transform",
                pointerEvents: "none"
            });
            document.body.appendChild(this.container);
        }
    }

    public render(content: HTMLElement): void {
        content.style.pointerEvents = "none";
        this.containerContents = content;
        this.container.innerHTML = "";
        this.container.appendChild(content);
    }

    public show(): void {
        this.container.style.display = "block";
        this.visible = true;
    }

    public hide(): void {
        this.container.style.display = "none";
        this.visible = false;
    }

    public isVisible(): boolean {
        return this.visible;
    }

    public moveTo(x: number, y: number): void {
        const offsetX = 10;
        const offsetY = 10;

        this.currentX = this.targetX = x + offsetX;
        this.currentY = this.targetY = y + offsetY;
        this.updatePosition();
    }

    public smoothMoveTo(x: number, y: number): void {
        const offsetX = 10;
        const offsetY = 10;

        this.targetX = x + offsetX;
        this.targetY = y + offsetY;

        if (!this.animationFrame) {
            this.animate();
        }
    }

    private animate = (): void => {
        const lerpFactor = 0.5;

        this.currentX += (this.targetX - this.currentX) * lerpFactor;
        this.currentY += (this.targetY - this.currentY) * lerpFactor;

        this.updatePosition();

        const dx = this.targetX - this.currentX;
        const dy = this.targetY - this.currentY;
        const distanceSq = dx * dx + dy * dy;

        if (distanceSq < 0.5 * 0.5) {
            this.currentX = this.targetX;
            this.currentY = this.targetY;
            this.updatePosition();

            this.animationFrame = null;
            return;
        }

        if (this.visible) {
            this.animationFrame = requestAnimationFrame(this.animate);
        } else {
            this.animationFrame = null;
        }
    };

    
    private updatePosition(): void {
        this.container.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;
    }

    public getElement(): HTMLDivElement {
        return this.container;
    }
    
    public getContents(): HTMLElement | null {
        return this.containerContents;
    }

    public getId(): string {
        return this.id;
    }
}
